/* eslint-disable */
//
// This file is auto-generated by build.ts
// Do not modify manually, please do: bun run wasm
//

/**
 * Mapping from original function names to minified WASM export names.
 * Using const enum so values are inlined at compile time.
 */
export const enum PdfiumExports {
  __assert_fail = "I",
  __cxa_throw = "h",
  __indirect_function_table = "X",
  __syscall_fcntl64 = "e",
  __syscall_fstat64 = "G",
  __syscall_ftruncate64 = "A",
  __syscall_getdents64 = "u",
  __syscall_ioctl = "H",
  __syscall_lstat64 = "E",
  __syscall_newfstatat = "D",
  __syscall_openat = "f",
  __syscall_rmdir = "s",
  __syscall_stat64 = "F",
  __syscall_unlinkat = "t",
  __wasm_call_ctors = "K",
  _abort_js = "i",
  _emscripten_runtime_keepalive_clear = "n",
  _emscripten_stack_restore = "si",
  _emscripten_throw_longjmp = "p",
  _emscripten_timeout = "qi",
  _gmtime_js = "v",
  _localtime_js = "w",
  _setitimer_js = "o",
  _tzset_js = "j",
  emscripten_builtin_memalign = "pi",
  emscripten_date_now = "g",
  emscripten_resize_heap = "q",
  emscripten_stack_get_current = "ti",
  environ_get = "y",
  environ_sizes_get = "z",
  fd_close = "a",
  fd_read = "d",
  fd_seek = "x",
  fd_sync = "B",
  fd_write = "c",
  FORM_CanRedo = "Je",
  FORM_CanUndo = "Ie",
  FORM_DoDocumentAAction = "Xe",
  FORM_DoDocumentJSAction = "Ve",
  FORM_DoDocumentOpenAction = "We",
  FORM_DoPageAAction = "Ye",
  FORM_ForceToKillFocus = "Me",
  FORM_GetFocusedAnnot = "Ne",
  FORM_GetFocusedText = "De",
  FORM_GetSelectedText = "Ee",
  FORM_IsIndexSelected = "_e",
  FORM_OnAfterLoadPage = "Te",
  FORM_OnBeforeClosePage = "Ue",
  FORM_OnChar = "Ce",
  FORM_OnFocus = "ue",
  FORM_OnKeyDown = "Ae",
  FORM_OnKeyUp = "Be",
  FORM_OnLButtonDoubleClick = "xe",
  FORM_OnLButtonDown = "ve",
  FORM_OnLButtonUp = "we",
  FORM_OnMouseMove = "se",
  FORM_OnMouseWheel = "te",
  FORM_OnRButtonDown = "ye",
  FORM_OnRButtonUp = "ze",
  FORM_Redo = "Le",
  FORM_ReplaceAndKeepSelection = "Fe",
  FORM_ReplaceSelection = "Ge",
  FORM_SelectAllText = "He",
  FORM_SetFocusedAnnot = "Oe",
  FORM_SetIndexSelected = "Ze",
  FORM_Undo = "Ke",
  FPDF_AddInstalledFont = "fg",
  FPDF_CloseDocument = "Q",
  FPDF_ClosePage = "Oh",
  FPDF_CloseXObject = "jf",
  FPDF_CopyViewerPreferences = "lf",
  FPDF_CountNamedDests = "ii",
  FPDF_CreateClipPath = "nh",
  FPDF_CreateNewDocument = "P",
  FPDF_DestroyClipPath = "oh",
  FPDF_DestroyLibrary = "sh",
  FPDF_DeviceToPage = "Qh",
  FPDF_DocumentHasValidCrossReferenceTable = "Bh",
  FPDF_FFLDraw = "Pe",
  FPDF_FreeDefaultSystemFontInfo = "lg",
  FPDF_GetDefaultSystemFontInfo = "kg",
  FPDF_GetDefaultTTFMap = "hg",
  FPDF_GetDefaultTTFMapCount = "ig",
  FPDF_GetDefaultTTFMapEntry = "jg",
  FPDF_GetDocPermissions = "Ch",
  FPDF_GetDocUserPermissions = "Dh",
  FPDF_GetFileIdentifier = "cc",
  FPDF_GetFileVersion = "Ah",
  FPDF_GetFormType = "vh",
  FPDF_GetLastError = "Ph",
  FPDF_GetMetaText = "dc",
  FPDF_GetNamedDest = "ki",
  FPDF_GetNamedDestByName = "ji",
  FPDF_GetPageAAction = "bc",
  FPDF_GetPageBoundingBox = "Lh",
  FPDF_GetPageCount = "Fh",
  FPDF_GetPageHeight = "Kh",
  FPDF_GetPageHeightF = "Jh",
  FPDF_GetPageLabel = "ec",
  FPDF_GetPageSizeByIndex = "ai",
  FPDF_GetPageSizeByIndexF = "$h",
  FPDF_GetPageWidth = "Ih",
  FPDF_GetPageWidthF = "Hh",
  FPDF_GetSecurityHandlerRevision = "Eh",
  FPDF_GetSignatureCount = "uf",
  FPDF_GetSignatureObject = "vf",
  FPDF_GetTrailerEnds = "oi",
  FPDF_GetXFAPacketContent = "ni",
  FPDF_GetXFAPacketCount = "li",
  FPDF_GetXFAPacketName = "mi",
  FPDF_ImportNPagesToOne = "gf",
  FPDF_ImportPages = "ff",
  FPDF_ImportPagesByIndex = "ef",
  FPDF_InitLibrary = "qh",
  FPDF_InitLibraryWithConfig = "rh",
  FPDF_LoadCustomDocument = "zh",
  FPDF_LoadDocument = "uh",
  FPDF_LoadMemDocument = "xh",
  FPDF_LoadMemDocument64 = "yh",
  FPDF_LoadPage = "Gh",
  FPDF_LoadXFA = "wh",
  FPDF_MovePages = "uc",
  FPDF_NewFormObjectFromXObject = "kf",
  FPDF_NewXObjectFromPage = "hf",
  FPDF_PageToDevice = "Rh",
  FPDF_RemoveFormFieldHighlight = "Se",
  FPDF_RenderPage_Close = "pf",
  FPDF_RenderPage_Continue = "of",
  FPDF_RenderPageBitmap = "Mh",
  FPDF_RenderPageBitmap_Start = "nf",
  FPDF_RenderPageBitmapWithColorScheme_Start = "mf",
  FPDF_RenderPageBitmapWithMatrix = "Nh",
  FPDF_SaveAsCopy = "qf",
  FPDF_SaveWithVersion = "rf",
  FPDF_SetFormFieldHighlightAlpha = "Re",
  FPDF_SetFormFieldHighlightColor = "Qe",
  FPDF_SetSandBoxPolicy = "th",
  FPDF_SetSystemFontInfo = "gg",
  FPDF_StructElement_Attr_CountChildren = "bg",
  FPDF_StructElement_Attr_GetBlobValue = "ag",
  FPDF_StructElement_Attr_GetBooleanValue = "Zf",
  FPDF_StructElement_Attr_GetChildAtIndex = "cg",
  FPDF_StructElement_Attr_GetCount = "Vf",
  FPDF_StructElement_Attr_GetName = "Wf",
  FPDF_StructElement_Attr_GetNumberValue = "_f",
  FPDF_StructElement_Attr_GetStringValue = "$f",
  FPDF_StructElement_Attr_GetType = "Yf",
  FPDF_StructElement_Attr_GetValue = "Xf",
  FPDF_StructElement_CountChildren = "Rf",
  FPDF_StructElement_GetActualText = "Hf",
  FPDF_StructElement_GetAltText = "Gf",
  FPDF_StructElement_GetAttributeAtIndex = "Lf",
  FPDF_StructElement_GetAttributeCount = "Kf",
  FPDF_StructElement_GetChildAtIndex = "Sf",
  FPDF_StructElement_GetChildMarkedContentID = "Tf",
  FPDF_StructElement_GetID = "If",
  FPDF_StructElement_GetLang = "Jf",
  FPDF_StructElement_GetMarkedContentID = "Nf",
  FPDF_StructElement_GetMarkedContentIdAtIndex = "eg",
  FPDF_StructElement_GetMarkedContentIdCount = "dg",
  FPDF_StructElement_GetObjType = "Pf",
  FPDF_StructElement_GetParent = "Uf",
  FPDF_StructElement_GetStringAttribute = "Mf",
  FPDF_StructElement_GetTitle = "Qf",
  FPDF_StructElement_GetType = "Of",
  FPDF_StructTree_Close = "Df",
  FPDF_StructTree_CountChildren = "Ef",
  FPDF_StructTree_GetChildAtIndex = "Ff",
  FPDF_StructTree_GetForPage = "Cf",
  FPDF_VIEWERREF_GetDuplex = "gi",
  FPDF_VIEWERREF_GetName = "hi",
  FPDF_VIEWERREF_GetNumCopies = "ci",
  FPDF_VIEWERREF_GetPrintPageRange = "di",
  FPDF_VIEWERREF_GetPrintPageRangeCount = "ei",
  FPDF_VIEWERREF_GetPrintPageRangeElement = "fi",
  FPDF_VIEWERREF_GetPrintScaling = "bi",
  FPDFAction_GetDest = "Ob",
  FPDFAction_GetFilePath = "Pb",
  FPDFAction_GetType = "Nb",
  FPDFAction_GetURIPath = "Qb",
  FPDFAnnot_AddFileAttachment = "jb",
  FPDFAnnot_AddInkStroke = "ia",
  FPDFAnnot_AppendAttachmentPoints = "sa",
  FPDFAnnot_AppendObject = "ka",
  FPDFAnnot_CountAttachmentPoints = "ta",
  FPDFAnnot_GetAP = "Ja",
  FPDFAnnot_GetAttachmentPoints = "ua",
  FPDFAnnot_GetBorder = "Ca",
  FPDFAnnot_GetColor = "pa",
  FPDFAnnot_GetFileAttachment = "ib",
  FPDFAnnot_GetFlags = "La",
  FPDFAnnot_GetFocusableSubtypes = "cb",
  FPDFAnnot_GetFocusableSubtypesCount = "bb",
  FPDFAnnot_GetFontColor = "_a",
  FPDFAnnot_GetFontSize = "Ya",
  FPDFAnnot_GetFormAdditionalActionJavaScript = "Sa",
  FPDFAnnot_GetFormControlCount = "eb",
  FPDFAnnot_GetFormControlIndex = "fb",
  FPDFAnnot_GetFormFieldAlternateName = "Ta",
  FPDFAnnot_GetFormFieldAtPoint = "Pa",
  FPDFAnnot_GetFormFieldExportValue = "gb",
  FPDFAnnot_GetFormFieldFlags = "Na",
  FPDFAnnot_GetFormFieldName = "Qa",
  FPDFAnnot_GetFormFieldType = "Ra",
  FPDFAnnot_GetFormFieldValue = "Ua",
  FPDFAnnot_GetInkListCount = "ya",
  FPDFAnnot_GetInkListPath = "za",
  FPDFAnnot_GetLine = "Aa",
  FPDFAnnot_GetLink = "db",
  FPDFAnnot_GetLinkedAnnot = "Ka",
  FPDFAnnot_GetNumberValue = "Ha",
  FPDFAnnot_GetObject = "ma",
  FPDFAnnot_GetObjectCount = "la",
  FPDFAnnot_GetOptionCount = "Va",
  FPDFAnnot_GetOptionLabel = "Wa",
  FPDFAnnot_GetRect = "wa",
  FPDFAnnot_GetStringValue = "Ga",
  FPDFAnnot_GetSubtype = "fa",
  FPDFAnnot_GetValueType = "Ea",
  FPDFAnnot_GetVertices = "xa",
  FPDFAnnot_HasAttachmentPoints = "qa",
  FPDFAnnot_HasKey = "Da",
  FPDFAnnot_IsChecked = "$a",
  FPDFAnnot_IsObjectSupportedSubtype = "ga",
  FPDFAnnot_IsOptionSelected = "Xa",
  FPDFAnnot_IsSupportedSubtype = "_",
  FPDFAnnot_RemoveInkList = "ja",
  FPDFAnnot_RemoveObject = "na",
  FPDFAnnot_SetAP = "Ia",
  FPDFAnnot_SetAttachmentPoints = "ra",
  FPDFAnnot_SetBorder = "Ba",
  FPDFAnnot_SetColor = "oa",
  FPDFAnnot_SetFlags = "Ma",
  FPDFAnnot_SetFocusableSubtypes = "ab",
  FPDFAnnot_SetFontColor = "Za",
  FPDFAnnot_SetFormFieldFlags = "Oa",
  FPDFAnnot_SetRect = "va",
  FPDFAnnot_SetStringValue = "Fa",
  FPDFAnnot_SetURI = "hb",
  FPDFAnnot_UpdateObject = "ha",
  FPDFAttachment_GetFile = "ub",
  FPDFAttachment_GetName = "ob",
  FPDFAttachment_GetStringValue = "sb",
  FPDFAttachment_GetSubtype = "vb",
  FPDFAttachment_GetValueType = "qb",
  FPDFAttachment_HasKey = "pb",
  FPDFAttachment_SetFile = "tb",
  FPDFAttachment_SetStringValue = "rb",
  FPDFAvail_Create = "yb",
  FPDFAvail_Destroy = "zb",
  FPDFAvail_GetDocument = "Bb",
  FPDFAvail_GetFirstPageNum = "Cb",
  FPDFAvail_IsDocAvail = "Ab",
  FPDFAvail_IsFormAvail = "Eb",
  FPDFAvail_IsLinearized = "Fb",
  FPDFAvail_IsPageAvail = "Db",
  FPDFBitmap_Create = "Sh",
  FPDFBitmap_CreateEx = "Th",
  FPDFBitmap_Destroy = "_h",
  FPDFBitmap_FillRect = "Vh",
  FPDFBitmap_GetBuffer = "Wh",
  FPDFBitmap_GetFormat = "Uh",
  FPDFBitmap_GetHeight = "Yh",
  FPDFBitmap_GetStride = "Zh",
  FPDFBitmap_GetWidth = "Xh",
  FPDFBookmark_Find = "Kb",
  FPDFBookmark_GetAction = "Mb",
  FPDFBookmark_GetCount = "Jb",
  FPDFBookmark_GetDest = "Lb",
  FPDFBookmark_GetFirstChild = "Gb",
  FPDFBookmark_GetNextSibling = "Hb",
  FPDFBookmark_GetTitle = "Ib",
  FPDFCatalog_IsTagged = "wb",
  FPDFCatalog_SetLanguage = "xb",
  FPDFClipPath_CountPaths = "kh",
  FPDFClipPath_CountPathSegments = "lh",
  FPDFClipPath_GetPathSegment = "mh",
  FPDFDest_GetDestPageIndex = "Rb",
  FPDFDest_GetLocationInPage = "Tb",
  FPDFDest_GetView = "Sb",
  FPDFDoc_AddAttachment = "lb",
  FPDFDoc_CloseJavaScriptAction = "bf",
  FPDFDoc_DeleteAttachment = "nb",
  FPDFDOC_ExitFormFillEnvironment = "re",
  FPDFDoc_GetAttachment = "mb",
  FPDFDoc_GetAttachmentCount = "kb",
  FPDFDoc_GetJavaScriptAction = "af",
  FPDFDoc_GetJavaScriptActionCount = "$e",
  FPDFDoc_GetPageMode = "me",
  FPDFDOC_InitFormFillEnvironment = "qe",
  FPDFFont_Close = "Wd",
  FPDFFont_GetAscent = "ge",
  FPDFFont_GetBaseFontName = "$d",
  FPDFFont_GetDescent = "he",
  FPDFFont_GetFamilyName = "ae",
  FPDFFont_GetFlags = "de",
  FPDFFont_GetFontData = "be",
  FPDFFont_GetGlyphPath = "je",
  FPDFFont_GetGlyphWidth = "ie",
  FPDFFont_GetIsEmbedded = "ce",
  FPDFFont_GetItalicAngle = "fe",
  FPDFFont_GetWeight = "ee",
  FPDFFormObj_CountObjects = "xd",
  FPDFFormObj_GetObject = "yd",
  FPDFFormObj_RemoveObject = "zd",
  FPDFGlyphPath_CountGlyphSegments = "ke",
  FPDFGlyphPath_GetGlyphPathSegment = "le",
  FPDFImageObj_GetBitmap = "kc",
  FPDFImageObj_GetIccProfileDataDecoded = "sc",
  FPDFImageObj_GetImageDataDecoded = "mc",
  FPDFImageObj_GetImageDataRaw = "nc",
  FPDFImageObj_GetImageFilter = "pc",
  FPDFImageObj_GetImageFilterCount = "oc",
  FPDFImageObj_GetImageMetadata = "qc",
  FPDFImageObj_GetImagePixelSize = "rc",
  FPDFImageObj_GetRenderedBitmap = "lc",
  FPDFImageObj_LoadJpegFile = "gc",
  FPDFImageObj_LoadJpegFileInline = "hc",
  FPDFImageObj_SetBitmap = "jc",
  FPDFImageObj_SetMatrix = "ic",
  FPDFJavaScriptAction_GetName = "cf",
  FPDFJavaScriptAction_GetScript = "df",
  FPDFLink_CloseWebLinks = "Vg",
  FPDFLink_CountQuadPoints = "$b",
  FPDFLink_CountRects = "Sg",
  FPDFLink_CountWebLinks = "Qg",
  FPDFLink_Enumerate = "Yb",
  FPDFLink_GetAction = "Xb",
  FPDFLink_GetAnnot = "Zb",
  FPDFLink_GetAnnotRect = "_b",
  FPDFLink_GetDest = "Wb",
  FPDFLink_GetLinkAtPoint = "Ub",
  FPDFLink_GetLinkZOrderAtPoint = "Vb",
  FPDFLink_GetQuadPoints = "ac",
  FPDFLink_GetRect = "Tg",
  FPDFLink_GetTextRange = "Ug",
  FPDFLink_GetURL = "Rg",
  FPDFLink_LoadWebLinks = "Pg",
  FPDFPage_CloseAnnot = "da",
  FPDFPage_CountObjects = "Ac",
  FPDFPage_CreateAnnot = "$",
  FPDFPage_Delete = "tc",
  FPDFPage_Flatten = "ne",
  FPDFPage_FormFieldZOrderAtPoint = "pe",
  FPDFPage_GenerateContent = "_c",
  FPDFPage_GetAnnot = "ba",
  FPDFPage_GetAnnotCount = "aa",
  FPDFPage_GetAnnotIndex = "ca",
  FPDFPage_GetArtBox = "gh",
  FPDFPage_GetBleedBox = "eh",
  FPDFPage_GetCropBox = "dh",
  FPDFPage_GetDecodedThumbnailData = "Wg",
  FPDFPage_GetMediaBox = "ch",
  FPDFPage_GetObject = "Bc",
  FPDFPage_GetRawThumbnailData = "Xg",
  FPDFPage_GetRotation = "wc",
  FPDFPage_GetThumbnailAsBitmap = "Yg",
  FPDFPage_GetTrimBox = "fh",
  FPDFPage_HasFormFieldAtPoint = "oe",
  FPDFPage_HasTransparency = "Cc",
  FPDFPage_InsertClipPath = "ph",
  FPDFPage_InsertObject = "xc",
  FPDFPage_InsertObjectAtIndex = "yc",
  FPDFPage_New = "vc",
  FPDFPage_RemoveAnnot = "ea",
  FPDFPage_RemoveObject = "zc",
  FPDFPage_SetArtBox = "bh",
  FPDFPage_SetBleedBox = "$g",
  FPDFPage_SetCropBox = "_g",
  FPDFPage_SetMediaBox = "Zg",
  FPDFPage_SetRotation = "fd",
  FPDFPage_SetTrimBox = "ah",
  FPDFPage_TransformAnnots = "ed",
  FPDFPage_TransFormWithClip = "hh",
  FPDFPageObj_AddMark = "Hc",
  FPDFPageObj_CountMarks = "Fc",
  FPDFPageObj_CreateNewPath = "Ad",
  FPDFPageObj_CreateNewRect = "Bd",
  FPDFPageObj_CreateTextObj = "Xd",
  FPDFPageObj_Destroy = "Dc",
  FPDFPageObj_GetBounds = "id",
  FPDFPageObj_GetClipPath = "jh",
  FPDFPageObj_GetDashArray = "vd",
  FPDFPageObj_GetDashCount = "ud",
  FPDFPageObj_GetDashPhase = "sd",
  FPDFPageObj_GetFillColor = "hd",
  FPDFPageObj_GetIsActive = "Yc",
  FPDFPageObj_GetLineCap = "qd",
  FPDFPageObj_GetLineJoin = "od",
  FPDFPageObj_GetMark = "Gc",
  FPDFPageObj_GetMarkedContentID = "Ec",
  FPDFPageObj_GetMatrix = "bd",
  FPDFPageObj_GetRotatedBounds = "jd",
  FPDFPageObj_GetStrokeColor = "ld",
  FPDFPageObj_GetStrokeWidth = "nd",
  FPDFPageObj_GetType = "Xc",
  FPDFPageObj_HasTransparency = "Rc",
  FPDFPageObj_NewImageObj = "fc",
  FPDFPageObj_NewTextObj = "Nd",
  FPDFPageObj_RemoveMark = "Ic",
  FPDFPageObj_SetBlendMode = "dd",
  FPDFPageObj_SetDashArray = "wd",
  FPDFPageObj_SetDashPhase = "td",
  FPDFPageObj_SetFillColor = "gd",
  FPDFPageObj_SetIsActive = "Zc",
  FPDFPageObj_SetLineCap = "rd",
  FPDFPageObj_SetLineJoin = "pd",
  FPDFPageObj_SetMatrix = "cd",
  FPDFPageObj_SetStrokeColor = "kd",
  FPDFPageObj_SetStrokeWidth = "md",
  FPDFPageObj_Transform = "$c",
  FPDFPageObj_TransformClipPath = "ih",
  FPDFPageObj_TransformF = "ad",
  FPDFPageObjMark_CountParams = "Kc",
  FPDFPageObjMark_GetName = "Jc",
  FPDFPageObjMark_GetParamBlobValue = "Qc",
  FPDFPageObjMark_GetParamFloatValue = "Oc",
  FPDFPageObjMark_GetParamIntValue = "Nc",
  FPDFPageObjMark_GetParamKey = "Lc",
  FPDFPageObjMark_GetParamStringValue = "Pc",
  FPDFPageObjMark_GetParamValueType = "Mc",
  FPDFPageObjMark_RemoveParam = "Wc",
  FPDFPageObjMark_SetBlobParam = "Vc",
  FPDFPageObjMark_SetFloatParam = "Tc",
  FPDFPageObjMark_SetIntParam = "Sc",
  FPDFPageObjMark_SetStringParam = "Uc",
  FPDFPath_BezierTo = "Gd",
  FPDFPath_Close = "Hd",
  FPDFPath_CountSegments = "Cd",
  FPDFPath_GetDrawMode = "Jd",
  FPDFPath_GetPathSegment = "Dd",
  FPDFPath_LineTo = "Fd",
  FPDFPath_MoveTo = "Ed",
  FPDFPath_SetDrawMode = "Id",
  FPDFPathSegment_GetClose = "Md",
  FPDFPathSegment_GetPoint = "Kd",
  FPDFPathSegment_GetType = "Ld",
  FPDFSignatureObj_GetByteRange = "xf",
  FPDFSignatureObj_GetContents = "wf",
  FPDFSignatureObj_GetDocMDPPermission = "Bf",
  FPDFSignatureObj_GetReason = "zf",
  FPDFSignatureObj_GetSubFilter = "yf",
  FPDFSignatureObj_GetTime = "Af",
  FPDFText_ClosePage = "ng",
  FPDFText_CountChars = "og",
  FPDFText_CountRects = "Gg",
  FPDFText_FindClose = "Og",
  FPDFText_FindNext = "Kg",
  FPDFText_FindPrev = "Lg",
  FPDFText_FindStart = "Jg",
  FPDFText_GetBoundedText = "Ig",
  FPDFText_GetCharAngle = "zg",
  FPDFText_GetCharBox = "Ag",
  FPDFText_GetCharIndexAtPos = "Eg",
  FPDFText_GetCharIndexFromTextIndex = "sf",
  FPDFText_GetCharOrigin = "Dg",
  FPDFText_GetFillColor = "xg",
  FPDFText_GetFontInfo = "vg",
  FPDFText_GetFontSize = "ug",
  FPDFText_GetFontWeight = "wg",
  FPDFText_GetLooseCharBox = "Bg",
  FPDFText_GetMatrix = "Cg",
  FPDFText_GetRect = "Hg",
  FPDFText_GetSchCount = "Ng",
  FPDFText_GetSchResultIndex = "Mg",
  FPDFText_GetStrokeColor = "yg",
  FPDFText_GetText = "Fg",
  FPDFText_GetTextIndexFromCharIndex = "tf",
  FPDFText_GetTextObject = "qg",
  FPDFText_GetUnicode = "pg",
  FPDFText_HasUnicodeMapError = "tg",
  FPDFText_IsGenerated = "rg",
  FPDFText_IsHyphen = "sg",
  FPDFText_LoadCidType2Font = "Sd",
  FPDFText_LoadFont = "Qd",
  FPDFText_LoadPage = "mg",
  FPDFText_LoadStandardFont = "Rd",
  FPDFText_SetCharcodes = "Pd",
  FPDFText_SetText = "Od",
  FPDFTextObj_GetFont = "_d",
  FPDFTextObj_GetFontSize = "Td",
  FPDFTextObj_GetRenderedBitmap = "Vd",
  FPDFTextObj_GetText = "Ud",
  FPDFTextObj_GetTextRenderMode = "Yd",
  FPDFTextObj_SetTextRenderMode = "Zd",
  free = "Z",
  invoke_ii = "r",
  invoke_iii = "b",
  invoke_iiii = "l",
  invoke_iiiii = "k",
  invoke_viii = "C",
  malloc = "Y",
  memory = "J",
  PDFKING_CopyTransparencyGroup = "W",
  PDFKING_ExportPageObjects = "O",
  PDFKING_HelloWorld = "L",
  PDFKING_ICC_ConvertPage = "U",
  PDFKING_ICC_CreateTransform = "S",
  PDFKING_ICC_DestroyTransform = "T",
  PDFKING_ICC_SoftProofBitmap = "V",
  PDFKING_PageObj_SetClipRect = "R",
  PDFKING_PageObj_SetFillColorCMYK = "M",
  PDFKING_PageObj_SetStrokeColorCMYK = "N",
  proc_exit = "m",
  setThrew = "ri"
}

/** Minified import module name */
export const IMPORT_MODULE = "a" as const;
